import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {
    FORM_FIELD_FULL_DATABASE,
    FORM_FIELD_FULLTEXT_SEARCH,
    FORM_FIELD_INTERNATIONAL,
    FORM_FIELD_ATTACHMENTS_ONLY,
    FORM_LABEL_ATTACHMENTS_ONLY,
    FORM_LABEL_FULL_DATABASE,
    FORM_LABEL_FULLTEXT_SEARCH,
    FORM_LABEL_INTERNATIONAL,
} from '../../../../constants/formConstants';
import {InputCheckBox} from '../../../common/InputCheckbox';
import {moduleRoles} from '../../../../utils/roles';
import {connect} from 'react-redux';
import fulltextSearchMessages from '../../../../intl/technicalDocumentations/fulltextSearchMessages';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const SearchOption = ({roles}) => {
    const isEditor = moduleRoles.isEditorDocumentation(roles);
    const isLvl1SgEditorOnly = moduleRoles.isSGEditorLVL1onlyDocumentation(roles);
    const isSGEditor = moduleRoles.isSGEditorDocumentation(roles);

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...fulltextSearchMessages.SEARCH_OPTION_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary p-4 bg-white">
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_FULLTEXT_SEARCH]}
                                       field={FORM_FIELD_FULLTEXT_SEARCH}/>
                    </div>
                </div>
                {moduleRoles.isDealerDocumentation(roles) &&
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_FULL_DATABASE]}
                                       field={FORM_FIELD_FULL_DATABASE}/>
                    </div>
                </div>
                }
                {(isEditor || isLvl1SgEditorOnly) &&
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_INTERNATIONAL]}
                                       field={FORM_FIELD_INTERNATIONAL}/>
                    </div>
                </div>
                }
                {(isSGEditor) &&
                <div className="form-row">
                    <div className="col-xl-4 col-lg-5 col-md-7 pb-2">
                        <InputCheckBox label={fulltextSearchMessages[FORM_LABEL_ATTACHMENTS_ONLY]}
                                       field={FORM_FIELD_ATTACHMENTS_ONLY}/>
                    </div>
                </div>
                }
            </StyledDiv>
        </>
    )
};

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {})(SearchOption);
